import React from 'react';

import Select, { SelectOption } from '@amzn/meridian/select';
import { setGlobalFilterOptions } from 'src/store/placementOverviewPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

const ANYONE = 'anyone';
const ME = 'me';

/** Filters both the placements table and the metrics by who created the placement. */
const CreatedByDropdown = () => {
  const dispatch = useAppDispatch();
  const { alias } = useAppSelector((state) => state.user);
  const { requesterLogin } = useAppSelector((state) => state.placementOverviewPage.globalFilterOptions);

  const selectCreatedBy = (createdBy: string) => {
    dispatch(setGlobalFilterOptions({ requesterLogin: createdBy === ME ? alias : null }));
  };

  return (
    <Select
      label="Created by"
      size="small"
      width={188}
      value={requesterLogin === null ? ANYONE : ME}
      onChange={selectCreatedBy}
    >
      <SelectOption value={ANYONE} label="Anyone" />
      <SelectOption value={ME} label="Me" />
    </Select>
  );
};

export default CreatedByDropdown;
